// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 1 hooks for backend/finance.

import { useBackend } from '../useBackend'

/** POST /api/finance/getProfitAndLoss */
export function useGetProfitAndLoss<T = any>() {
  return useBackend<T>('finance/getProfitAndLoss')
}
